// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__2ev5s","message":"CookieConsent_message__mfpvL","cookieLink":"CookieConsent_cookieLink__1xEK-","continueBtn":"CookieConsent_continueBtn__2O8W3"};